import React from 'react';
import classNames from 'classnames';

import gql from 'graphql-tag';
import {
  Item2AdminButtonsData,
} from '../schemas/rql';
import { withPrefix } from '../lib/i18n_helpers';
import URLHelpers from './shared/url_helpers';
import { useUser } from '@reverbdotcom/commons/src/user_hooks';

interface IProps {
  listing: Item2AdminButtonsData.Fragment;
}

const t = withPrefix('discovery.adminButtons');

export const Item2AdminButtonsFragment = gql`
  fragment Item2AdminButtonsData on Listing {
    _id
    id
    slug
    canonicalProductId
  }
`;

export function Item2AdminButtons({ listing }: IProps) {
  const user = useUser();

  if (!user.isAdmin || !listing) { return null; }

  const defaultClasses = 'button button--small width-100 icon-l-lock';
  const echidnaClasses = classNames(
    defaultClasses,
    { 'button--primary': !(listing.canonicalProductId === '') },
  );

  return (
    <div className="item2__sidebar-module">
      <div className="d-flex fx-wrap" style={{ margin: '-0.5rem' }}>
        <div className="mlr-half mtb-half" style={{ flex: '1' }}>
          <a
            className={echidnaClasses}
            href={URLHelpers.echidnaListingPage(listing.id)} data-echidna-link>
            {t('openInEchidna')}
          </a>
        </div>
        <div className="mlr-half mtb-half" style={{ flex: '1' }}>
          <a
            className={defaultClasses}
            href={URLHelpers.adminFlagRoute(listing.id, listing.slug)}
            data-view-flags-link
          >
            {t('viewFlags')}
          </a>
        </div>
      </div>
    </div>
  );
}
